export const contrasts = {
  h1: 0.75,
  h2: 0.75,
  h3: 0.85,
  h4: 0.85,
  h5: 0.95,
  h6: 0.95,
  subtitle1: 0.9,
  subtitle2: 0.75,
  body2: 1,
  body1: 1,
  caption: 0.67,
  button: 0.87,
  overline: 0.87,
};
export const fontWeights = {
  h1: '100',
  h2: '100',
  h3: '500',
  h4: '500',
  h5: '500',
  h6: '600',
  subtitle1: '400',
  subtitle2: '500',
  body1: '500',
  body2: '400',
  caption: '400',
  button: '700',
  overline: '500',
};
export const fontSizes = {
  h1: 96,
  h2: 60,
  h3: 48,
  h4: 34,
  h5: 24,
  h6: 20,
  subtitle1: 16,
  subtitle2: 14,
  body1: 16,
  body2: 14,
  caption: 12,
  button: 14,
  overline: 14,
};
export const letterSpacings = {
  h1: -1.5,
  h2: -0.5,
  h3: 0,
  h4: 0.25,
  h5: 0,
  h6: 0.15,
  subtitle1: 0.15,
  subtitle2: 0.1,
  body1: 0.5,
  body2: 0.25,
  caption: 0.4,
  button: 1.25,
  overline: 1.5,
};
